const CLEANUP_DELAY_MS = 500;
const CLEANUP_FALLBACK_MS = 60000;

// Obrazac se stampa iz privremenog iframe-a da stilovi aplikacije ne bi uticali
// na ispis, i da nista ne bi ostalo u DOM-u nakon stampe.
const printHtmlDocument = (html) =>
  new Promise((resolve) => {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('title', 'Obrazac za postu');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.style.visibility = 'hidden';

    let settled = false;
    let fallbackTimer = null;

    const cleanup = () => {
      if (settled) return;
      settled = true;
      clearTimeout(fallbackTimer);
      // Chrome zove afterprint pre nego sto zavrsi sa dokumentom iz iframe-a.
      setTimeout(() => {
        frame.remove();
        resolve();
      }, CLEANUP_DELAY_MS);
    };

    let printTriggered = false;

    frame.onload = () => {
      if (printTriggered) return;
      printTriggered = true;

      const frameWindow = frame.contentWindow;
      if (!frameWindow) {
        cleanup();
        return;
      }

      frameWindow.addEventListener('afterprint', cleanup, { once: true });
      fallbackTimer = setTimeout(cleanup, CLEANUP_FALLBACK_MS);

      frameWindow.focus();
      frameWindow.print();
    };

    frame.srcdoc = html;
    document.body.appendChild(frame);
  });

export default printHtmlDocument;
